import { Box, Tab, Typography } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { tabsClasses } from '@mui/material/Tabs';
import React, { useContext, useEffect, useState } from 'react';

import BotMessages from '../components/BotMessages';
import ClinicSettings from '../components/ClinicSettings';
import BranchesSettings from '../components/BranchesSettings';
import AdminsSettings from '../components/AdminsSettings';
import AiIntegrationComponent from '../components/AiIntegrationComponent';
import Profile from '../components/Profile';
import PaymentPage from './PaymentPage';
import { Context } from '..';
import AmenityList from '../components/AmenityList/AmenityList';
import WebhooksSettings from '../components/WebhooksSettings';
import Statistics from "../components/Statistics";
import Surveys from '../components/Surveys';
import CancellationReasons from '../components/CancellationReasons/CancellationReasons';
import SmsAeroSettings from '../components/SmsAeroSettings';

const Settings = () => {
  const { user } = useContext(Context);

  const savedTab = localStorage.getItem('currentTab') || '1'; // '1' — это вкладка по умолчанию
  const [value, setValue] = useState(savedTab);

  const tabs = [
    { label: 'Профиль', value: '1', component: <Profile /> },
    { label: 'Счёт и оплата', value: '2', component: <PaymentPage /> },
    // {
    //   label: 'Дополнительные функции',
    //   value: '3',
    //   component: <AiIntegrationComponent />,
    // },
    { label: 'Настройки клиники', value: '4', component: <ClinicSettings /> },
    { label: 'Филиалы', value: '5', component: <BranchesSettings /> },
    { label: 'Администраторы', value: '6', component: <AdminsSettings /> },
    // { label: 'Врачи', value: '7', component: <DoctorsSettings /> },
    { label: 'Сообщения бота', value: '8', component: <BotMessages /> },
    { label: 'Статистика', value: '9', component: <Statistics /> },
    { label: 'Напитки', value: '10', component: <AmenityList/> },
    { label: 'Веб-хуки', value: '11', component: <WebhooksSettings /> },
    { label: 'Опросы', value: '12', component: <Surveys /> },
    {
      label: 'Справочники',
      value: '13',
      component: (
        <Box>
          <Typography variant="h5" sx={{ mb: 3 }}>Справочники</Typography>
          <CancellationReasons />
        </Box>
      ),
    },
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem('currentTab', newValue);
  };

  useEffect(() => {
    // Восстановить состояние вкладки при загрузке страницы
    const savedTab = localStorage.getItem('currentTab');
    if (savedTab) {
      setValue(savedTab);
    }
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList
            aria-label='Settings tabs'
            onChange={handleChange}
            textColor='secondary'
            indicatorColor='secondary'
            variant='scrollable'
            scrollButtons
            sx={{
              [`& .${tabsClasses.scrollButtons}`]: {
                '&.Mui-disabled': { opacity: 0.3 },
              },
            }}
          >
            {tabs
              .map((tab) => {
                if (tab.label !== 'Администраторы')
                  return (
                    <Tab key={tab.value} label={tab.label} value={tab.value} />
                  );
                else {
                  if (user.isOwner) {
                    return (
                      <Tab
                        key={tab.value}
                        label={tab.label}
                        value={tab.value}
                      />
                    );
                  } else return null;
                }
              })
              .filter((tab) => tab !== null)}
          </TabList>
        </Box>
        {tabs.map((tab) => (
          <TabPanel key={tab.value} value={tab.value}>
            {tab.component}
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
};

export default Settings;
